import React, { useState } from "react";
import HeroLayout from "../components/HeroLayout";
import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneNumberField from "../components/PhoneNumberField";

const images = require.context("../assets/images", false);
function Contact() {
     const [formData, setFormData] = useState({
      name: "",
      email: "",
      countryCode: "+91",
      phone: "",
      message: ""
    });
    const [captchaToken, setCaptchaToken] = useState(null);
  
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState("");
  
    // Handle Input Change
    const handleChange = (e) => {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value
      });
  
      setErrors({
        ...errors,
        [e.target.name]: ""
      });
    };
  
    // Validation Function
    const validate = () => {
      let newErrors = {};
  
      if (!formData.name.trim()) {
        newErrors.name = "Name is required";
      }
  
      if (!formData.email.trim()) {
        newErrors.email = "Email is required";
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
        newErrors.email = "Invalid email format";
      }
  



      if (!formData.phone.trim()) {
    newErrors.phone = "Phone number is required";
  } else if (!/^[0-9]{7,15}$/.test(formData.phone)) {
    newErrors.phone = "Enter valid phone number";
  }
  
      if (!formData.message.trim()) {
        newErrors.message = "Message is required";
      }

      if (!captchaToken) {
        newErrors.captcha = "Please verify captcha";
      }
  
      return newErrors;
    };
  
    // Submit Form
    const handleSubmit = async (e) => {
      e.preventDefault();
  
      const validationErrors = validate();
  
      if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        return;
      }
  
      try {
        setLoading(true);
  
        const response = await fetch("https://www.luxurygoldentriangle.com/bkadmn/wp-json/custom/v1/contact", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ...formData,
            phone: `${formData.countryCode} ${formData.phone}`.trim(),
            captcha: captchaToken
          })
        });
  
        const data = await response.json();
  
        if (data.success) {
          setSuccess("Message sent successfully!");
          setFormData({
            name: "",
            email: "",
            countryCode: "+91",
            phone: "",
            message: ""
          });
          setCaptchaToken(null);
          setErrors({});
        } else {
          setSuccess(data.message || "Something went wrong.");
        }
  
      } catch (error) {
        setSuccess("Server error. Please try again.");
      } finally {
        setLoading(false);
      }
    };
  
  
  return (
         <>
    <HeroLayout>
    <div
        className="banner-bg bg-center"
        style={{
            backgroundImage:
            `linear-gradient(#370b2e66, #370b2e66), url(${images("./contactusimg.jpeg")})`
        }}
        >
        <div className="container">
            <div className="inner-banner-content full-width center color-white mt-5">
            <h1>Contact Us</h1>
            </div>
        </div>
        </div>

    </HeroLayout>
    <div className="contact-form mt-80">
  <div className="container">
    <div className="row align-items-center">
      <div className="col-md-12 col-lg-6">
        <div className="heading max-420">
          <h2>Contact Us</h2>
          <p>Our team is here to help you. If you need any information or want to book a tour, please contact us on below mentioned details.</p>
  
        </div>
        <div className="contact-info">
          <div className="contact-info-card">
            <h3 className="mb-3">Call Us</h3>
            <Link to="tel:91 9416575716">+91 9416575716</Link>

          </div>
          <div className="contact-info-card">
            <h3 className="mb-3">Our Location</h3>
            <p style={{ textAlign: "justify" }}>296, Ground Floor, Chitrakoot Apartments, QU Block, Uttari Pitampura, Pitampura, New Delhi, Delhi, 110034</p>
          </div>
          <div className="contact-info-card">
            <h3 className="mb-3">Email</h3>
            <Link to="mailto:contact@luxurygoldentriangle.com">contact@luxurygoldentriangle.com</Link>
          </div>
          <div className="contact-info-card">
            <h3 className="mb-3">Social Network</h3>
            <div className="social-icon">
                          <Link to="https://www.facebook.com/LuxuryGoldenTriangleTour" target="_blank">
                <img src={images("./facebook.svg")} alt="facebook" />
              </Link>
              <Link to="https://www.instagram.com/luxurygoldentriangle/" target="_blank">
                <img src={images("./instagram.svg")} />
              </Link>
              <Link to="https://www.linkedin.com/in/luxurygoldentriangle/" target="_blank">
                <img src={images("./linkdin.svg")} alt="twiter" />
              </Link>
             
              <Link to="https://wa.me/919416575716" target="_blank">
                <img src={images("./whatsapp.svg")} alt="whatsapp" />
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-12 col-lg-6">
        <div className="form-card">
          <div className="heading">
            <h3>Send Us a Message</h3>
            <p>
              Fill out the form below and our team will contact you within 24 hours.
            </p>
          </div>
          <form onSubmit={handleSubmit} noValidate>
            <div className="row">
              <div className="col-md-12 col-lg-6">
                <div className="form-input-group mb-4">
                  <label htmlFor="name">
                    Name<span>*</span>
                  </label>
                <input
                  type="text"
                  name="name"
                  placeholder="Enter your name"
                  value={formData.name}
                  onChange={handleChange}
                  className="form-control"
                />
                {errors.name && <p className="error">{errors.name}</p>}
                </div>
              </div>
              <div className="col-md-12 col-lg-6">
                <div className="form-input-group mb-4">
                  <label htmlFor="name">
                    Email<span>*</span>
                  </label>
                   <input
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-control"
                  />
                  {errors.email && <p className="error">{errors.email}</p>}
                </div>
              </div>
              <div className="col-md-12">
                <PhoneNumberField
                  countryCode={formData.countryCode}
                  value={formData.phone}
                  onChange={handleChange}
                  error={errors.phone}
                />
              </div>
              <div className="col-md-12">
                <div className="form-input-group mb-2">
                  <label htmlFor="name">
                    Message<span>*</span>
                  </label>
                  <textarea
                    name="message"
                    placeholder="Write your message"
                    value={formData.message}
                    onChange={handleChange}
                    className="form-control"
                  />
                  {errors.message && <p className="error">{errors.message}</p>}
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <ReCAPTCHA
                sitekey="6Ld4kHosAAAAAKsayfQ1saymv6SeauUSxkHSn55b"
                onChange={(token) => {
                  setCaptchaToken(token);
                  setErrors({
                    ...errors,
                    captcha: ""
                  });
                }}
              />
              {errors.captcha && <p className="error">{errors.captcha}</p>}
            </div>
            <div className="form-btn center mt-3">
           
              <button type="submit" disabled={loading} className="primary-btn">
                {loading ? "Sending..." : "Submit"} <img src={images("./arrow-right-btn.svg")} alt="Arrow" />
              </button>
                 {success && <p className="success">{success}</p>}

              <p className="center mt-2 privacy-note">
                Your information is safe with us. We respect your privacy.
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

    </>
  );
}

export default Contact;
